import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS animation styles
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Import Components
import Layout from './components/Layout';
import Contact from './components/Contact';
import Home from './components/Home';
import Service from './components/Service';
import Feature from './components/Feature';

const App = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/service/:id" element={<Service />} />
          <Route path="/feature/:id" element={<Feature />} />
          <Route path='contact' element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
